import Vue from 'vue'

/**
 * Redesign Stockists Component
 */
Vue.component('stockists', {
  props: [
    'stockistsJson'
  ],
  data () {
    return {
      selectedCountry: '',
      selectedCategory: ''
    }
  },
  computed: {
    countries () {
      const countries = this.stockistsJson.map((data) => {
        return (data && data.country_name)
      })

      return this.getUnique(countries)
    },
    categories () {
      const categories = this.stockistsJson.map((data) => {
        return (data && (data.category || data.cateogry))
      })

      return this.getUnique(categories)
    },
    categoryOptions () {
      const categories = this.stockistsJson
        .filter((data) => {
          return !this.selectedCountry || (data && data.country_name === this.selectedCountry)
        })
        .map((data) => {
          return data && (data.category || data.cateogry)
        })

      return this.getUnique(categories)
        .map((category) => {
          return {
            key: this.normalizeCategory(category),
            value: category
          }
        })
        .filter((category) => category.key)
    },
    storeItems () {
      let items = this.stockistsJson

      if (this.selectedCountry) {
        items = items.filter((data) => {
          return (data && data.country_name && (data.country_name === this.selectedCountry))
        })
      }

      if (this.selectedCategory) {
        items = items.filter((data) => {
          const category = data && (data.category || data.cateogry)
          return (category && (category === this.selectedCategory))
        })
      }

      return items
    }
  },
  methods: {
    getUnique (data) {
      if (data) {
        return [...new Set(data)]
      } else {
        return []
      }
    },
    normalizeCategory (category) {
      const normalizedCategory = (category || '')
        .toLowerCase()
        .replace(/[\s-]+/g, '_')

      if (normalizedCategory === 'in_store' || normalizedCategory === 'online') {
        return normalizedCategory
      }

      return ''
    },
    selectCategory (category) {
      this.selectedCategory = category
    },
    selectCountry (country) {
      this.selectedCountry = country
      this.selectedCategory = this.categoryOptions.length
        ? this.categoryOptions[0].value
        : ''
    }
  },
  mounted () {
    const country = this.stockistsJson.map((data) => {
      return (data && data.country_name)
    })

    if (country) {
      const filteredCountries = this.getUnique(country)
      this.selectedCountry = filteredCountries[0]
      this.selectedCategory = this.categoryOptions.length
        ? this.categoryOptions[0].value
        : ''
    }
  }
})
